// extracted by mini-css-extract-plugin
export default {"comments-section":"lsf-comments-section","comments-section__header":"lsf-comments-section__header","comments-section__title":"lsf-comments-section__title","waiting":"lsf-waiting"};